import { FC, HTMLAttributes } from 'react';

import { Flex, Typography } from 'antd';
import cn from 'classnames';

import EllipseIcon from 'assets/images/icons/ellipse.svg?react';
import { STATUSES } from 'shared/consts';

import styles from './BadgeStatus.module.scss';

interface IBadgeStatusProps extends HTMLAttributes<HTMLDivElement> {
	status: string;
	text?: string;
}

export const BadgeStatus: FC<IBadgeStatusProps> = ({
	className,
	status,
	text,
	...props
}) => {
	const iconClass = `icon_${status}`;

	return (
		<Flex
			{...props}
			className={cn(className)}
			gap={8}
			align='center'>
			<EllipseIcon className={styles[iconClass]}/>
			<Typography.Text>{text || STATUSES[status as keyof typeof STATUSES]}</Typography.Text>
		</Flex>
	);
};
